(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('OnuInfoController', OnuInfoController);

    OnuInfoController.$inject = ['$scope', '$rootScope', '$uibModalInstance', 'dataAction'];

    function OnuInfoController($scope, $rootScope, $uibModalInstance, dataAction) {
        var vm = this;
        vm.requestRunning = false;

        if (dataAction) {
            vm.action = dataAction.action;

            vm.close = function () {
                if (!vm.requestRunning) {
                    $uibModalInstance.dismiss('cancel');
                }
            };

        }

    }
})();

